<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms">
      <v-card pa-0>
        <v-toolbar card dark v-bind:color="parent ? parent.color:'black'">
          <v-toolbar-title class="white--text">{{parent ? parent.akronim : null}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <router-link v-bind:to="{path: formPath, query:$route.query}">
              <v-btn color="cyan" fab small dark>
                <v-icon>edit</v-icon>
              </v-btn>  
          </router-link>
          <router-link v-bind:to="{path: viewPath, query:$route.query}">
              <v-btn color="info" fab small dark>
                <v-icon>find_in_page</v-icon>
              </v-btn>  
          </router-link>
        </v-toolbar>        
        <v-toolbar card color="white">
          <v-text-field
          flat
          solo
          prepend-icon="search"
          placeholder="Type something"
          v-model="search"
          hide-details
          ></v-text-field>     
          <!--<v-btn icon>
            <v-icon>filter_list</v-icon>
          </v-btn>-->
                     
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text v-model="calons" class="pa-0 dapil-scroll tabular">
          <v-data-table
            :headers="complex.headers"
            :search="search"
            :items="complex.items"
            :loading="loading"
            :pagination.sync="pagination"
            :rows-per-page-items="[25,50,{text:'All','value':-1}]"
            class="elevation-1"
            hide-actions
            item-key="id"                            
            v-model="complex.selected"
            >
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>  
            <template slot="items" slot-scope="props">                              
              <td style="width:1px;">{{ props.item.no }}</td>
              <td>{{ props.item.name }}</td>                              
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>        
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Model from '@/apps/frc/models/Calon';    

var model = new Model();

export default {
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
        id : null,
        formPath : '/calon/form',
        viewPath : '/calon/view',
        search   : '',
        loading  : false,
        pagination: {},
        complex  : {
            selected: [],
            headers: [
              { text: 'No', value: 'no'  },
              { text: 'Calon', value: 'name'},              
            ],
            items: []
        },
    }),  
    mounted(){  }, 
    asyncComputed: { 
         
        parent(){           
            this.id = this.$route.query.id;
            if(!this.id)return;
            this.loading = true;
            return model.one({id:this.id}).then(res=>{                
                return res;
            });
        }, 
        calons(){            
            this.kompetisi_id = this.$route.query.kompetisi_id;
            this.dapil_id     = this.$route.query.dapil_id ? this.$route.query.dapil_id : null;
            this.id           = this.$route.query.id;
            if(!this.id)return;
            this.loading = true;
            return model.all({'CalonSearch[kompetisi_id]':this.kompetisi_id,
                'CalonSearch[dapil_id]':this.dapil_id,'CalonSearch[parent_id]':this.id
            }).then(res=>{             
                this.complex.items = res;
                this.loading = false;
                return res;
            });
        }        
    },
    created () {
        if( model.vuex ){
            var context = this;        
            context.$store.watch(
                function (state) { return state },
                function () { model.all().then(data => { context.complex.items = data }) },{ deep: true }
            );                                     
        }
    },
    methods: {      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},
        
        init(){
            if(this.$route.query.flag){ 
                Object.assign(this.pagination, {sortBy : 'flag', descending:true});
            }
            model.all().then(data => {      
                this.complex.items = data; 
                this.loading = false;
            });                                         
        },
                     
        firstLetter (name) {            
            return name ? name.charAt(0): null;
        },
        
        calonRoute (id) {
            this.$router.push({path:'/calon', query: {
                kompetisi_id: this.$route.query.kompetisi_id, 
                mode: this.$route.query.mode,  
                dapil_id:this.$route.query.dapil_id,
                parent_id:id
            }});
        },
    }
}
</script>
